import React, { useEffect } from "react";
import api from "API/api";
import * as Yup from "yup";
import { toast } from "sonner";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "../components/BasicLayout";
import MDTypography from "components/MDTypography";
import { ErrorMessage, Field, Form, Formik } from "formik";
import bgImage from "assets/images/ai-background.jpg";
import { useNavigate, useParams } from "react-router-dom";

const ResetPassword = () => {
  const { id, token } = useParams();

  const navigate = useNavigate();
  const initialValues = { new_password: "", con_password: "" };

  const validationSchema = Yup.object({
    new_password: Yup.string().required("New password is required"),
    con_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const handleSubmit = async (values) => {
    try {
      const { new_password, con_password } = values;

      const res = await api.post(`/reset-password/${id}/${token}`, {
        new_password,
        con_password,
      });
      toast.success(res?.data?.message);
      navigate("/login");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <BasicLayout image={bgImage}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="success"
            mx={2}
            mt={-3}
            py={2}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              Reset Password
            </MDTypography>
          </MDBox>
          <MDBox pt={5} pb={5} px={3}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form>
                  <MDBox mb={4}>
                    <MDBox mb={2}>
                      <Field name="new_password">
                        {({ field }) => (
                          <MDInput
                            {...field}
                            type="text"
                            label="New Password"
                            fullWidth
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="new_password"
                        component="div"
                        style={{
                          color: "red",
                          fontSize: "11px",
                          marginLeft: "4px",
                        }}
                      />
                    </MDBox>
                    <MDBox mb={2}>
                      <Field name="con_password">
                        {({ field }) => (
                          <MDInput
                            {...field}
                            type="text"
                            label="Confirm Password"
                            fullWidth
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="con_password"
                        component="div"
                        style={{
                          color: "red",
                          fontSize: "11px",
                          marginLeft: "4px",
                        }}
                      />
                    </MDBox>
                  </MDBox>
                  <MDBox mt={6} mb={1}>
                    <MDButton
                      type="submit"
                      variant="gradient"
                      color="info"
                      fullWidth
                    >
                      Reset
                    </MDButton>
                  </MDBox>
                </Form>
              )}
            </Formik>
          </MDBox>
        </Card>
      </BasicLayout>
    </>
  );
};

export default ResetPassword;
